import { ResponseHelper } from '../_helpers/response.helper'
import axiosInstance from './axios.service'
import { C100Payload, C100Timeframe } from '../_types/carnivore100.type'

export class Carnivore100Service {
  private setError: (message: string | null) => void

  constructor(setError: (message: string | null) => void) {
    this.setError = setError
  }

  async getTable(timeframe: C100Timeframe): Promise<C100Payload | { errMsg: string }> {
    // hard timeout so a stuck backend surfaces as a retryable error,
    // never an infinite loading state
    return axiosInstance
      .get('/carnivore-100', { params: { timeframe }, timeout: 30000 })
      .then(res => res.data.data as C100Payload)
      .catch(async e => {
        const result = await ResponseHelper.handleError(e, this.setError)
        return result || { errMsg: 'an error occurred' }
      })
  }
}
